import React, { useState, useRef, useEffect } from 'react';
import { Helmet } from 'react-helmet-async'
import { FormControl, Grid, TableHead, Stack, Table, TableBody, TableCell, TableContainer, TextField, TableRow, Typography, Card, CardContent, Button } from '@mui/material'
import { yearlydashboardData } from './_mock/user';
import { DataGrid, GridEditInputCell, useGridApiContext  } from '@mui/x-data-grid';
import { Box } from '@mui/system';
import clsx from 'clsx';
import { FinancialYearDropdown } from './FinancialYearDropdown';
import { CustomButton } from '../../common/custom-button/customButton';
import { loaderService } from '../../common/custom-loader/loader-service';

import { GET_ANNUALDASHBOARD, authKey, UPDATE_MONTHLYDEMAND_MONSOONFACTOR } from '../../common/URLs';
import { ToastContainer, toast } from 'react-toastify';
import { DEMAND_CONSTANTS } from '../../common/constants';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { styled } from '@mui/material/styles';
import { DEMAND_VALIDATIONS } from '../../common/commonValidations';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import apiClient from '../../axios';

// ----------------------------------------------------------------------

function YearlyDashboard() {
  let updatedDashboardData = {}
  const [apiArr, setApiArr] = useState([]);
  const [idList, setIdList] = useState([]);
  const uuid = localStorage.getItem('uuid');

  const [isMonthlyDemandEditable, setIsMonthlyDemandEditable] = useState(false);
  const [isIntrimStorageEditable, setIsIntrimStorageEditable] = useState(false);
  const [annualDashboardList, setAnnualDashboardList] = useState([]);
  const [isCalculateDashboardDisabled, setIsCalculateDashboardDisabled] = useState(true);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState();
  const [pageSize, setPageSize] = React.useState(10);
  
  const [reCalculateDashboardDialog, setReCalculateDashboardDialog] = useState(false);
  const handleReCalculateDashboardDialogOpen = () => setReCalculateDashboardDialog(true);
  const handleReCalculateDashboardDialogClose = () => setReCalculateDashboardDialog(false);

  const StyledBox = styled(Box)(({ theme }) => ({
    height: "inherit",
    width: '100%',
    '& .MuiDataGrid-cell--editing': {
      backgroundColor: 'rgb(255,215,115, 0.19)',
      color: '#1a3e72',
      '& .MuiInputBase-root': {
        height: '100%',
      },
    },
    '& .Mui-error': {
      backgroundColor: `rgb(126,10,15, ${theme.palette.mode === 'dark' ? 0 : 0.1})`,
      color: theme.palette.error.main,
    },
  }));

  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText,
    },
  }));

    function EditInputCell(props) {
          const { error, id, value: valueProp, field } = props;
          const [value, setValue] = useState(valueProp);
          const apiRef = useGridApiContext();
  
          const handleChange = (event) => {
              const newValue = event.target.value; 
              apiRef.current.setEditCellValue({ id, field, value: newValue });
              setValue(newValue);
          };
  
          useEffect(() => {
              setValue(valueProp);
          }, [valueProp]);
          
          return (
              <StyledTooltip open={!!error} title={error}>
                  <GridEditInputCell {...props} value={value} onChange={handleChange} />
             </StyledTooltip>
          );
      }
  
  function renderEdit(params) {
    return <EditInputCell {...params} />;
  }

  const [columnDefs] = useState([
    {
      field: 'month',
      headerName: 'Month',
      valueFormatter: (params) => {
        if (params.value === 1) return 'Apr'
        else if (params.value === 2) return 'May'
        else if (params.value === 3) return 'Jun'
        else if (params.value === 4) return 'Jul'
        else if (params.value === 5) return 'Aug'
        else if (params.value === 6) return 'Sep'
        else if (params.value === 7) return 'Oct'
        else if (params.value === 8) return 'Nov'
        else if (params.value === 9) return 'Dec'
        else if (params.value === 10) return 'Jan'
        else if (params.value === 11) return 'Feb'
        else if (params.value === 12) return 'Mar'
      }

    },
    {
      field: 'monthlyDemand',
      headerName: 'Monthly CB Demand (in MT)',
      minWidth: 220,
      type: 'number',
      editable: true,
      sortable: false,
      preProcessEditCellProps: (params) => {
        return { ...params.props, error: DEMAND_VALIDATIONS.dataGridValidation(params.props.value, 8, 2) };
      },
      renderEditCell: renderEdit,
    },
    {
      field: 'monthlyRbDemandWithMoisture',
      headerName: 'Monthly RB Demand (in MT)',
      minWidth: 220,
      type: 'number',
      sortable: false
    },
    {
      field: 'monthlyRbDemand',
      headerName: 'Monthly Bone Dry RB Demand (in MT)',
      minWidth: 280,
      type: 'number',
      editable: true,
      sortable: false
    },
    {
      field: 'operatingDays',
      headerName: 'Plant Operating Days',
      minWidth: 200,
      editable: true,
      type: 'number',
      sortable: false
    },
    {
      field: 'expectedAvailabilityWithMoisture',
      headerName: 'Expected Bamboo Availability(in MT)',
      minWidth: 280,
      type: 'number',
      editable: true,
      sortable: false
    },
    {
      field: 'expectedAvailability',
      headerName: 'Expected BoneDry RB Availability(in MT)',
      minWidth: 280,
      type: 'number',
      editable: true,
      sortable: false
    },
    {
      field: 'expectedDeliveryShortfall',
      headerName: 'Expected Delivery Shortfall(in MT)',
      minWidth: 250,
      type: 'number',
      editable: true,
      sortable: false
    },

    {
      field: 'isBuildupOrderQty',
      headerName: 'Is Buildup Qty(in MT)',
      minWidth: 200,
      type: 'number',
      editable: true,
      sortable: false
    },
    {
      field: 'growerMonthlyPo',
      headerName: 'Grower Monthly PO(in MT)',
      headerClassName: 'super-app-theme--header',
      minWidth: 200,
      editable: true,
      type: 'number',
      sortable: false
    },
    {
      field: 'actualAllocation',
      headerName: 'Actual Allocation(in MT)',
      headerClassName: 'super-app-theme--header',
      minWidth: 200,
      editable: true,
      type: 'number',
      sortable: false
    },
    {
      field: 'planningStatus',
      headerName: 'Planning Status',
      minWidth: 150,
      editable: true,
      sortable: false,
      valueFormatter: (params) => {
        if (params.value === 1) {
          return 'Open';
        } else return 'Closed'
      },
    },


  ])
  //const classes = useStyles();


  const getSelectedValue = (dataToBePassed) => {
    setSelectedFinancialYear(dataToBePassed);
    getAnnualDashboard(dataToBePassed);

  }

  const onHandleEditMonthlyDemand = () => {
    setIsMonthlyDemandEditable(!isMonthlyDemandEditable);
    setIsCalculateDashboardDisabled(false)

  }
  const onHandleEditISBuildup = () => {
    setIsIntrimStorageEditable(!isIntrimStorageEditable);

  }

const onConfirmReCalculateDashboard = (e) => {
  handleReCalculateDashboardDialogClose();
  let filteredArrayData = annualDashboardList?.filter(o => ((!idList.includes(o.id)) && o.planningStatus === 1)).map((item) => {
    return {
      "financialYear": item.financialYear,
      "month": item.month,
      "monthlyDemand": item.monthlyDemand,
      "expectedDeliveryShortfall": item.expectedDeliveryShortfall,
      "isBuildupOrderQty": item.isBuildupOrderQty,
      "growerMonthlyPo": item.growerMonthlyPo
    }
  })
  filteredArrayData.push(...apiArr);
  filteredArrayData.map((i) => {
    if (i.month === 10) i.month = 'Jan'
    else if (i.month === 11) i.month = 'Feb'
    else if (i.month === 12) i.month = 'Mar'
    else if (i.month === 1) i.month = 'Apr'
    else if (i.month === 2) i.month = 'May'
    else if (i.month === 3) i.month = 'Jun'
    else if (i.month === 4) i.month = 'Jul'
    else if (i.month === 5) i.month = 'Aug'
    else if (i.month === 6) i.month = 'Sep'
    else if (i.month === 7) i.month = 'Oct'
    else if (i.month === 8) i.month = 'Nov'
    else if (i.month === 9) i.month = 'Dec'
  })
  reCalculateDashboardApi(filteredArrayData);
}

  const onHandleRecalculateDashboard = (e) => {
    handleReCalculateDashboardDialogOpen();
  }

  const handleEditableRows = (params) => {
    if (isMonthlyDemandEditable === true) {
      return (params.colDef.field === "monthlyDemand" && params.row.planningStatus === 1)
    } else return false


  }
  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow };
    annualDashboardList.forEach((item) => {
      if (item.month === newRow.month) {
        item.monthlyDemand = newRow.monthlyDemand
      }
    })
    let data = {
      "financialYear": updatedRow.financialYear,
      "month": updatedRow.month,
      "monthlyDemand": parseFloat(updatedRow.monthlyDemand),
      "expectedDeliveryShortfall": parseFloat(updatedRow.expectedDeliveryShortfall),
      "isBuildupOrderQty": updatedRow.isBuildupOrderQty,
      "growerMonthlyPo": updatedRow.growerMonthlyPo
    }
    const tempApiArr = [...apiArr]
    const tempIdList = [...idList]
    if (tempApiArr.length !== 0) {
      let objExist = tempApiArr?.filter(obj => obj.month === data.month);
      if (objExist?.length > 0) {
          objExist[0].monthlyDemand = data.monthlyDemand
      } else tempApiArr.push(data);
  } else tempApiArr.push(data);
  if (tempIdList.length !== 0) {
    let objExist = tempIdList?.filter(item => item === updatedRow.id);
    if (objExist?.length > 0) {
        // do nothing
    } else tempIdList.push(updatedRow.id);
} else tempIdList.push(updatedRow.id);
    
    setApiArr(tempApiArr);
    setIdList(tempIdList);
    return updatedDashboardData = updatedRow
  };


  // -----------------API Calls-------------------

  const getAnnualDashboard = (year) => {
    loaderService.showLoader();
    apiClient.post(GET_ANNUALDASHBOARD,
      {
        "financialYear": year,
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        if (response.data.annualDashboardLst) {
          if (response.data.annualDashboardLst.length === 0) {
            toast.info(DEMAND_CONSTANTS.NoDataMessage)
          }
          const mappedData = response.data.annualDashboardLst?.map((item) => {
            return {
              "id": item.demandAnnualDashboard.id,
              "financialYear": item.demandAnnualDashboard.financialYear,
              "month": item.demandAnnualDashboard.month,
              "operatingDays": item.demandAnnualDashboard.operatingDays,
              "monthlyDemand": item.demandAnnualDashboard.monthlyDemand,
              "expectedDeliveryShortfall": item.demandAnnualDashboard.expectedDeliveryShortfall,
              "isBuildupOrderQty": item.demandAnnualDashboard.isBuildupOrderQty,
              "growerMonthlyPo": item.demandAnnualDashboard.growerMonthlyPo,
              "planningStatus": item.demandAnnualDashboard.planningStatus,
              "actualAllocation": item.demandAnnualDashboard.actualAllocation,
              "monthlyRbDemand": item.monthlyRbDemand,
              "monthlyRbDemandWithMoisture": item.monthlyRbDemandWithMoisture,
              "expectedAvailability": item.expectedAvailability,
              "expectedAvailabilityWithMoisture": item.expectedAvailabilityWithMoisture
            }
          })
          mappedData.map((i) => {
            if (i.month === 'Jan') i.month = 10
            else if (i.month === 'Feb') i.month = 11
            else if (i.month === 'Mar') i.month = 12
            else if (i.month === 'Apr') i.month = 1
            else if (i.month === 'May') i.month = 2
            else if (i.month === 'Jun') i.month = 3
            else if (i.month === 'Jul') i.month = 4
            else if (i.month === 'Aug') i.month = 5
            else if (i.month === 'Sep') i.month = 6
            else if (i.month === 'Oct') i.month = 7
            else if (i.month === 'Nov') i.month = 8
            else if (i.month === 'Dec') i.month = 9
          })
          setAnnualDashboardList(mappedData)
        } else {
          setAnnualDashboardList([])
        }
        loaderService.hideLoader();
      }).catch(function (error) {
        toast.error(error.message)
        loaderService.hideLoader();
      });


  }

  const reCalculateDashboardApi = (data) => {
    loaderService.showLoader();
    apiClient.post(UPDATE_MONTHLYDEMAND_MONSOONFACTOR + `?userId=${uuid}`,
      data,
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        toast.success(response.data.message)
        getAnnualDashboard(selectedFinancialYear);
        setIsCalculateDashboardDisabled(true);
        setIsMonthlyDemandEditable(false);
        setApiArr([]);
        setIdList([]);
        loaderService.hideLoader();
      }).catch(function (error) {
        toast.error(error.message)
        loaderService.hideLoader();
      });


  }

  return (

    <Card>
      <CardContent>
        <Stack gap={1}>
          <Grid container spacing={1}>
            <Grid item xs={12} lg={2}>
              <FinancialYearDropdown selectedValue={getSelectedValue} isDisabled={false} />
            </Grid>
            <Grid item xs={10} lg={10} >
              <Stack direction="row" spacing={1} sx={{ float: 'right' }}>
                <CustomButton
                  title="Re-calculate Dashboard"
                  disabled={isCalculateDashboardDisabled || annualDashboardList?.length === 0}
                  onClick={(e) => onHandleRecalculateDashboard(e)} />
                <CustomButton
                  disabled={annualDashboardList?.length === 0 || selectedFinancialYear === 'select'}
                  title="Edit"
                  onClick={(e) => onHandleEditMonthlyDemand(e)} />
              </Stack>
            </Grid>

          </Grid>
          <Box
            sx={{
              height: '100%',
              width: '100%',
              '& .super-app-theme--0': {
                backgroundColor: '#ededed',
                color: '#1a3e72',
                fontWeight: '600',
              },
              '& .super-app-theme--cell': {
                backgroundColor: '#ededed',
                color: '#1a3e72',
                fontWeight: '600',
              },
              '& .super-app-theme--header': {
                wordWrap: 'break-word',
                wordBreak: 'break-all',
                whiteSpace: 'initial',
              },
              '& .MuiDataGrid-cell--editable': {
                bgcolor: (theme) =>
                  theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
              },
              '& .Mui-error': {
                                backgroundColor: `rgb(126,10,15,0.1)`,
                                color: (theme) => theme.palette.error.main,
                            },
            }}>
           
              <DataGrid
                autoHeight
                columns={columnDefs}
                rows={annualDashboardList}
                disableColumnMenu={true}
                experimentalFeatures={{ newEditingApi: true }}
                isCellEditable={(params) => handleEditableRows(params)}
                processRowUpdate={processRowUpdate}
                initialState={{
                  sorting: {
                    sortModel: [{ field: 'month', sort: 'asc' }],
                  },
                }}
                pagination
                pageSize={pageSize}
                onPageSizeChange={(newPage) => setPageSize(newPage)}
                getRowClassName={(params) => `super-app-theme--${params.row.planningStatus}`}
                components={{
                  NoRowsOverlay: () => (
                    <Stack height="100%" alignItems="center" justifyContent="center">
                      No rows available
                    </Stack>
                  ),
                }}
              />
            
          </Box>
        </Stack>
      </CardContent>
      <ConfirmationPopover onOpen={reCalculateDashboardDialog} onConfirm={onConfirmReCalculateDashboard} onClose={handleReCalculateDashboardDialogClose} action="Re-Calculate Dashboard" />
    </Card>

  )
}

export default YearlyDashboard